import {SemanticLegendByMetric} from '../../../../../generated/graphql';
import {YAxisValues} from '../../types';
import {DEFAULT_SEMANTIC_LEGEND_SETTINGS} from '../SemanticLegendDefaults';
import {parseBucketsFromSemanticLegendByMetric} from './parseBuckets';

export function constructSemanticLegendData(
  currentMetric?: string,
  semanticLegendsByMetric?: SemanticLegendByMetric[]
) {
  if (!semanticLegendsByMetric || !currentMetric) {
    return DEFAULT_SEMANTIC_LEGEND_SETTINGS;
  }

  const currentLegend = semanticLegendsByMetric?.find(
    legend => legend?.metricName === currentMetric
  );
  if (currentLegend) {
    const {buckets, bucketCustomizations} =
      parseBucketsFromSemanticLegendByMetric(currentLegend);
    return {
      bucketCustomizations: bucketCustomizations,
      buckets: buckets,
      currentMetric: currentMetric ?? '',
      excludedRunColor: currentLegend?.excludedRunColor ?? '',
      metric: currentLegend?.metricName ?? '',
      metricName: currentLegend?.metricName ?? '',
      numberOfBuckets: buckets.length ?? 0,
      yAxisValue: (currentLegend?.yValue as YAxisValues) ?? YAxisValues.Min,
    };
  }
  return DEFAULT_SEMANTIC_LEGEND_SETTINGS;
}
